<script setup lang="ts">
import {useDisplay} from "vuetify";

defineProps<{
  title?: string,
  loading?: boolean
}>()

const {extraWide} = storeToRefs(useCustomizerStore())
const {mobile} = useDisplay()
const route = useRoute()
const icon = route.meta.icon
</script>

<template>
  <div class="d-flex justify-center flex-grow-1" style="min-height: calc(100vh - 90px)">
    <div :class="extraWide ? `flex-grow-1 mx-8` : 'fixed-width flex-grow-1'" class="pt-6">
      <perfect-scrollbar :options="{suppressScrollY: !mobile, suppressScrollX: !mobile}" class="pb-8">
        <div>
          <div class="d-flex gap-3 pl-1 align-center">
            <component v-if="icon" :is="icon" :size="$route.meta.iconSize ?? 28"></component>
            <h2>{{ title ?? $route.meta.name }}</h2>
            <v-spacer/>
            <div class="d-flex gap-4">
              <EnvironmentSelector/>
            </div>
          </div>

          <v-divider class="mt-1 mb-3"/>

          <div style="height: 4px">
            <v-progress-linear height="4" v-if="loading" indeterminate color="primary"/>
          </div>

          <slot name="left"></slot>
          <slot></slot>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
  <div class="sidebar-container">
    <template v-if="$.slots.right !== undefined">
      <v-navigation-drawer location="right" class="sidebar-content" :width="mobile ? 200 : 350"
                           permanent elevation="1">
        <div class="px-2" style="padding-top: 36px">
          <slot name="right"></slot>
        </div>
      </v-navigation-drawer>
    </template>
  </div>
</template>

<style scoped>

.sidebar-content {
  background-color: var(--v-sidebar-color);
}
</style>